import { useZip } from '@/features/account/services/Zip/hooks'
import { isValidZip } from '@/features/shared/utils/validator'
import { useSearchQueryParams } from '@/features/shared/hooks/search'

/**
 * @returns preferred zip code to use on marketing pages.
 * This could be the user zip, guest zip, or zip query param.
 */
export const useMarketingZip = () => {
  const searchParams = useSearchQueryParams()
  const contextualZip = useZip() ?? ''
  const queryZip = searchParams.zip ? String(searchParams.zip) : ''
  const zip = isValidZip(queryZip) ? queryZip : contextualZip
  return isValidZip(zip) ? zip : ''
}
